import { Pages, Validators } from '@briq/core'
import { useTranslation } from 'react-i18next'

export function useRegisterPageConfig(): Pages.RegisterPageConfig {
  const { t } = useTranslation('form')
  return {
    additionalFields: [
      {
        name: 'phone',
        label: t('ContactNumber'),
        placeholder: t('ContactNumberPlaceholder'),
        type: 'text',
        interceptor: Validators.maxLengthInterceptor(16)
      }
    ]
  }
}
